var _classCallCheck = require("/home/travis/build/Jungle-Bus/Busy-Hours/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/Jungle-Bus/Busy-Hours/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/Jungle-Bus/Busy-Hours/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/Jungle-Bus/Busy-Hours/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/Jungle-Bus/Busy-Hours/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/home/travis/build/Jungle-Bus/Busy-Hours/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var TransportThumbnail =
/*#__PURE__*/
function (_HTMLElement) {
  "use strict";

  _inherits(TransportThumbnail, _HTMLElement);

  function TransportThumbnail() {
    var _this;

    _classCallCheck(this, TransportThumbnail);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TransportThumbnail).call(this));
    _this._shadowRoot = _this.attachShadow({
      mode: 'open'
    });
    return _this;
  }

  _createClass(TransportThumbnail, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var network = this.getAttribute("data-transport-network");
      var lineColour = this.getAttribute("data-transport-line-color");
      var lineCode = this.getAttribute("data-transport-line-code");
      var mode = this.getAttribute("data-transport-mode");
      var destination = this.getAttribute("data-transport-destination");
      var displayMode = '';

      switch (mode) {
        case 'bus':
          displayMode = '🚍';
          break;

        case 'train':
          displayMode = '🚆';
          break;

        case 'subway':
        case 'metro':
          displayMode = '🚇';
          break;

        case 'tramway':
        case 'tram':
          displayMode = '🚊';
          break;

        case 'ferry':
          displayMode = '⛴️';
          break;

        case 'walking_bus':
          displayMode = '🚶';
          break;

        default:
          displayMode = '🚍';
          break;
      }

      var html = "\n    <style>\n        .transport_thumbnail {\n            border-bottom-width: 4px;\n            border-bottom-style: solid;\n            border-bottom-left-radius: 3px;\n            border-bottom-right-radius: 3px;\n            border-bottom-color:".concat(lineColour || "white", ";\n        }\n    </style>\n\n    <span class=\"transport_thumbnail\">\n        ").concat(network ? "[" + network + "]" : "", "\n        ").concat(displayMode, "\n        ").concat(lineCode || "??", "\n    </span>\n    ").concat(destination ? "> " + destination : "", "\n    ");
      this._shadowRoot.innerHTML = html;
    }
  }]);

  return TransportThumbnail;
}(_wrapNativeSuper(HTMLElement));

customElements.define('transport-thumbnail', TransportThumbnail);